import { setAttr } from '../helpers/dom';
import { trigger } from '../helpers/event';

export default class Header {
  constructor() {
    const htmlEl = document.querySelector('html');

    // const headerEl = document.querySelector('[data-header]');

    const spaceEl = document.querySelector('[data-header-space]');

    let lastScrollTop = 0;

    function onScroll(e) {
      const { scrollTop } = e.detail;

      const isNotTop = scrollTop > spaceEl.offsetHeight;
      const isScrollDown = scrollTop >= lastScrollTop;

      // setAttr(headerEl, 'data-header-not-top', isNotTop ? '' : null);
      // setAttr(headerEl, 'data-header-scroll-down', isScrollDown ? '' : null);

      setAttr(htmlEl, 'data-header-is-top', !isNotTop ? '' : null);
      setAttr(htmlEl, 'data-header-not-top', isNotTop ? '' : null);
      setAttr(htmlEl, 'data-header-scroll-down', isScrollDown ? '' : null);

      trigger(window, 'HeaderScrollDown', {
        isScrollDown,
        scrollTop,
      });

      lastScrollTop = scrollTop;
    }

    window.addEventListener('liteScroll', onScroll);

    function destroy() {
      window.removeEventListener('liteScroll', onScroll);
    }

    return {
      destroy,
    };
  }
}
